var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"projectInfoDetails"},[_c('h5',[_vm._v(_vm._s(_vm.clickItem.title))]),_c('span',[_vm._v("更新时间:"+_vm._s(_vm.clickItem.time))]),_c('div',{staticClass:"imgBox"},[_c('el-image',{staticStyle:{"width":"100%"},attrs:{"src":_vm.clickItem.imgUrl,"fit":"contain"}})],1),_c('p',[_vm._v(_vm._s(_vm.clickItem.content))])])
}
var staticRenderFns = []

export { render, staticRenderFns }